import { z } from '@harvestiq/zod';
import {
  CoverageTiers,
  LgmCampaignPdfColumns,
  RmaLgmTypeCodes,
} from '@harvestiq/constants';
import { zCalendarDate, zDecimalNullable } from '@harvestiq/zod';

export const getLgmQuoteCampaignSchema = z.object({
  typeCode: z.nativeEnum(RmaLgmTypeCodes),
  message: z.string().optional(),
  recipientUserIds: z.array(z.string().uuid()), // User IDs
  numberOfHead: z.coerce.number(),
  marketingMonths: z.array(z.coerce.number()),
  targetSalesEffectiveDate: zCalendarDate().optional(),
  deductibles: z.array(z.coerce.number().int().min(0).max(150)).optional(),
  liveCattleTargetCwtPerHead: zDecimalNullable().optional(),
  feederCattleTargetCwtPerHead: zDecimalNullable().optional(),
  cornTargetBuPerHead: zDecimalNullable().optional(),
  coverageTier: z.nativeEnum(CoverageTiers).optional(),
  quoteColumns: z.array(z.nativeEnum(LgmCampaignPdfColumns)),
});

export type GetLgmQuoteCampaign = z.input<typeof getLgmQuoteCampaignSchema>;
